import React, { ChangeEvent, FC } from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { Button } from 'src/components/Button';
import { PasswordInput } from 'src/components/Forms/FormInputs/PasswordInput';
import { TextField } from '@mui/material';
import {
  Form,
  InputsWrapper,
} from 'src/components/Forms/ChangePasswordForm/styled';

export interface ChangePasswordFormValues {
  email: string;
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;
}

interface ChangePasswordFormProps {
  onSubmit: SubmitHandler<ChangePasswordFormValues>;
  loading: boolean;
  userEmail: string;
}

export const ChangePasswordForm: FC<ChangePasswordFormProps> = ({
  onSubmit,
  loading,
  userEmail,
}) => {
  const {
    formState: { errors, isValid },
    setValue,
    handleSubmit,
    trigger,
  } = useFormContext<ChangePasswordFormValues>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === 'newPassword') {
      trigger('repeatPassword');
    }

    setValue(name as keyof ChangePasswordFormValues, value, {
      shouldValidate: true,
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <InputsWrapper>
        <TextField label="Email" value={userEmail} disabled fullWidth />
        <PasswordInput
          error={!!errors.currentPassword}
          helperText={errors.currentPassword?.message || ' '}
          label="Current password"
          name="currentPassword"
          onChange={handleChange}
        />
        <PasswordInput
          error={!!errors.newPassword}
          helperText={errors.newPassword?.message || ' '}
          label="New password"
          name="newPassword"
          onChange={handleChange}
        />
        <PasswordInput
          error={!!errors.repeatPassword}
          helperText={errors.repeatPassword?.message || ' '}
          label="Repeat new password"
          name="repeatPassword"
          onChange={handleChange}
        />
      </InputsWrapper>
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid}
        loading={loading}
      >
        Change password
      </Button>
    </Form>
  );
};
